import { isRouteErrorResponse, useRouteError } from "react-router";

import { ButtonLink } from "../components/ButtonLink";
import { EmptyBlock, ErrorBlock } from "../components/States";
import { useTranslation } from "../lib/i18n";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="ada-page">
      <EmptyBlock icon="search" title={t("Page not found")} description={t("This address matches no ada screen.")}>
        <ButtonLink variant="primary" to="/projects">
          {t("Back to projects")}
        </ButtonLink>
      </EmptyBlock>
    </div>
  );
}

/** Router error boundary: a render crash or a failed lazy chunk (after a deploy). */
export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : t("Unexpected error");
  return (
    <div className="ada-full-screen">
      <div className="ada-stack">
        <ErrorBlock
          title={t("This screen could not be displayed")}
          error={new Error(t("{{message}}. Reload the page: a new version of ada may have been deployed.", { message }))}
          onRetry={() => window.location.reload()}
        />
      </div>
    </div>
  );
}
